import { Controller } from "@hotwired/stimulus"

// "Copy link" on the admin invitation result panel. Clipboard API first;
// if that is missing or refused, select the whole link so the admin can
// copy it by hand (long-press on a phone). The link is never logged.
export default class extends Controller {
  static targets = ["field", "button", "label", "status"]

  async copy() {
    const text = this.fieldTarget.value
    try {
      if (!navigator.clipboard || !window.isSecureContext) throw new Error("no clipboard")
      await navigator.clipboard.writeText(text)
      this.copied()
    } catch (_error) {
      this.selectForManualCopy()
    }
  }

  select() {
    this.fieldTarget.focus()
    this.fieldTarget.setSelectionRange(0, this.fieldTarget.value.length)
  }

  copied() {
    this.labelTarget.textContent = "Copied"
    this.buttonTarget.dataset.copied = "true"
    this.statusTarget.textContent = "Copied. Paste it into your message to the owner."
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => {
      this.labelTarget.textContent = "Copy link"
      delete this.buttonTarget.dataset.copied
    }, 4000)
  }

  selectForManualCopy() {
    this.select()
    this.statusTarget.textContent = "Couldn't copy automatically. The link is selected: copy it now (long-press on a phone, Ctrl+C or Cmd+C on a computer)."
  }

  disconnect() {
    clearTimeout(this.resetTimer)
  }
}
